import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Icon } from '@material-ui/core';

const Rating = ({ onChange, val, id }) => {
  const disableStatuses = ['In Progress', 'Scheduled', 'Completed', 'enrolled', 'in_progress'];
  const quality = val.rating?.courseQuality ?? val.rating?.sessionQuality ?? null;
  return (
    <IconButton disabled={disableStatuses.includes(val.status)} size="small" onClick={() => onChange(id, val.rating)}>
      {quality === null ? <Icon>star_border</Icon> : <Icon>star</Icon>}
    </IconButton>
  );
};

Rating.defaultProps = {
  onChange: () => {},
};

Rating.propTypes = {
  onChange: PropTypes.func,
  val: PropTypes.shape({
    status: PropTypes.string.isRequired,
    rating: PropTypes.shape({
      courseQuality: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.oneOf([null])]),
      sessionQuality: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.oneOf([null])]),
    }).isRequired,
  }).isRequired,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default Rating;
